import Vue from "vue";
import qs from "qs";
import axios from "axios";
import store from "@/vuex";
import router from '@/router';
import { domain } from "@/env";
import { message } from 'ant-design-vue';




axios.defaults.baseURL = domain + 'api/';
axios.defaults.headers["Authorization"] = 'Bearer ' + store.state.token;
axios.defaults.headers["Content-Type"]  = "application/x-www-form-urlencoded;charset=UTF-8";


axios.interceptors.response.use(
    response => {
        const code = response.data.code || 0;
        switch (code) {
            case 200:
                return Promise.resolve(response);
            case 1001:
                message.error('请重新登录');
                router.push({ name: 'login' });
                return Promise.reject(response);
            default:
                return Promise.reject(response);
        }
    },
    error => {
        // console.log('api err', error);
        // console.log('api err', error.response);
        if (error.response.status) {
            switch (error.response.status) {
                case 404:
                    break;
                default:
                    break;
            }
        }
        return Promise.reject(error.response);
    }
);

export function $get(url, data) {
    let _self = this;
    return new Promise((resolve, reject) => {
        axios
            .get(url, { params: data })
            .then(res => {
                if (res.data.status == "ok") {
                    resolve(res.data);
                } else {
                    res.data.message != '' && message.error(res.data.message);
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                let errorData = error.data;
                errorData.message != '' && message.error(errorData.message);
                resolve(errorData);
            });
    });
}

export function $post(url, data) {
    let _self = this;
    return new Promise((resolve, reject) => {
        //qs.stringify()将对象序列化成URL的形式，以&进行拼接
        axios
            .post(url, qs.stringify(data))
            .then(res => {
                if (res.data.status == "ok") {
                    resolve(res.data);
                } else {
                    res.data.message != '' && message.error(res.data.message);
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                let errorData = error.data;
                errorData.message != '' && message.error(errorData.message);
                resolve(errorData);
            });
    });
}

export function $put(url, data) {
    let _self = this;
    return new Promise((resolve, reject) => {
        axios
            .put(url, qs.stringify(data))
            .then(res => {
                if (res.data.status == "ok") {
                    resolve(res.data);
                } else {
                    res.data.message != '' && message.error(res.data.message);
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                let errorData = error.data;
                errorData.message != '' && message.error(errorData.message);
                resolve(errorData);
            });
    });
}

export function $delete(url, data) {
    let _self = this;
    return new Promise((resolve, reject) => {
        axios
            .delete(url, { data: qs.stringify(data) })
            .then(res => {
                if (res.data.status == "ok") {
                    resolve(res.data);
                } else {
                    res.data.message != '' && message.error(res.data.message);
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                let errorData = error.data;
                errorData.message != '' && message.error(errorData.message);
                resolve(errorData);
            });
    });
}

export function $download() {
    let _self = this;
    return new Promise((resolve, reject) => {
        //qs.stringify()将对象序列化成URL的形式，以&进行拼接
        axios
            .post(url, qs.stringify(data), {
                responseType: "blob"
            })
            .then(res => {
                if (res.data.size) {
                    resolve(res.data);
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let link = document.createElement("a");
                    link.innerHTML = fileName;
                    link.download = fileName;
                    link.href = URL.createObjectURL(blob);
                    link.click();
                } else {
                    res.data.message != '' && message.error(res.data.message);
                }
            })
            .catch(function (error) {
                message.error('下载失败');
                resolve(error);
            });
    });
}



// WEBPACK FOOTER //
// ./src/api/config/index.js